import { Permissionable } from './Permissionable';

export class Role extends Permissionable {}
